import { Routes } from '@angular/router';

import { projectsSegments } from '@advania-cosoftware/wolf-router';

export const projectsRoutes: Routes = [
    {
        path: projectsSegments.projects,
        loadComponent: () => import('./features/projects-home/projects-home.page').then((m) => m.ProjectsHomePage),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: projectsSegments.list,
            },
            {
                path: projectsSegments.list,
                loadComponent: () =>
                    import('./features/projects-list/projects-list.page').then((m) => m.ProjectsListPage),
            },
        ],
    },
];
